import { useStateWithSearchParams } from "../../hooks";
import { Dropdown } from "./dropdown/Dropdown";

const query = "limit";
const items = ["Top 10", "Top 50", "Top 100"];

type SearchParams = {
  [key: string]: string | undefined;
};

export const TopDropdown = () => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      ["trend"]: undefined,
    },
  );

  return (
    <Dropdown
      label={""}
      placeholder={"Top"}
      selectedItem={{
        value: searchDict[query] ? `Top ${searchDict[query]}` : items[0],
      }}
      items={items.map((value) => ({ value }))}
      onChange={({ value }) => setSearchValue(query, value.split(" ")[1])}
      maxHeight={"132px"}
      maxItemsWidth={"100%"}
    />
  );
};
